var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /app/~/buffer/~/isarray/index.js
// module id = ../../../../buffer/node_modules/isarray/index.js
// module chunks = 7